import { render, staticRenderFns } from "./SelectedResourcesLayout.vue?vue&type=template&id=b9d2a534"
import script from "./SelectedResourcesLayout.vue?vue&type=script&lang=js"
export * from "./SelectedResourcesLayout.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports